// import React from 'react'

// const Institutionsspecific = () => {
//   return (
//     <div>Institutionsspecific</div>
//   )
// }

// export default Institutionsspecific





// import React, { useEffect, useState } from "react";
// import "../../styles/studentProfile.css";
// import ReusableChart from "../ReusableComponent/Chart";
// import img from "../../assets/Loginimg/male.png";
// import { getWithTokenAPI, putWithTokenAPI } from "../../util/Api";
// import { useSelector } from "react-redux";
// import { useNavigate, useParams } from "react-router-dom";
// import { SafeToast } from "../Toast/ShowToast";
// import Noimage from "../../assets/Noimg3.jpg";
// import { ChevronLeft } from "lucide-react";
// import { institution_dashboard } from "../../util/Apiendpoits";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   ResponsiveContainer,
//   CartesianGrid,
// } from "recharts";
// import SelectDropdown from "../ReusableComponent/SelectDropdown";
// const Institutionsspecific = () => {
//   const [isApproved, setapproved] = useState(false);
//   const [profile, setProfile] = useState(null);
//   const { token, userId } = useSelector((state) => state.auth);
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [Courses, setCourses] = useState(0);
//   const [chartData, setChartData] = useState([]);

//   const currentYear = new Date().getFullYear();
//   const minYear = 2026;
//   const maxYear = currentYear + 1;
//   const [selectedFilters, setSelectedFilters] = useState({
//     month: "",
//     year: "",
//   });

//   const filters = {
//     userTypes: [
//       { value: "", label: "All Users" },
//       { value: "dealer", label: "Dealer" },
//       { value: "consumer", label: "Consumer" },
//       { value: "both", label: "Both" },
//     ],
//     months: [
//       { value: "", label: "All Months" },
//       { value: "01", label: "January" },
//       { value: "02", label: "February" },
//       { value: "03", label: "March" },
//       { value: "04", label: "April" },
//       { value: "05", label: "May" },
//       { value: "06", label: "June" },
//       { value: "07", label: "July" },
//       { value: "08", label: "August" },
//       { value: "09", label: "September" },
//       { value: "10", label: "October" },
//       { value: "11", label: "November" },
//       { value: "12", label: "December" },
//     ],
//     years: [
//       { value: "", label: "All Years" },
//       ...Array.from({ length: maxYear - minYear + 1 }, (_, i) => {
//         const year = maxYear - i; // descending order
//         return {
//           value: String(year),
//           label: String(year),
//         };
//       }),
//     ],
//   };

//   const handleFilterChange = (key, value) => {
//     setSelectedFilters((prev) => ({
//       ...prev,
//       [key]: value,
//     }));
//   };

//   const fetchChart = async () => {
//     try {
//       const res = await getWithTokenAPI(
//         token,
//         `/institution/${id}/student-count`,
//       );

//       if (res?.success) {
//         let students = res.data?.students || [];
//         const { month, year } = selectedFilters;

//         // 🔹 SELECT MONTH & YEAR (fallback current)
//         const selectedMonth =
//           month || String(new Date().getMonth() + 1).padStart(2, "0");
//         const selectedYear = year || String(new Date().getFullYear());

//         // 🔹 FILTER BY MONTH & YEAR
//         students = students.filter((student) => {
//           if (!student.subscribedAt) return false;

//           const d = new Date(student.subscribedAt);
//           const m = String(d.getMonth() + 1).padStart(2, "0");
//           const y = String(d.getFullYear());

//           return m === selectedMonth && y === selectedYear;
//         });

//         // 🔹 TOTAL DAYS IN MONTH
//         const daysInMonth = new Date(
//           selectedYear,
//           Number(selectedMonth),
//           0,
//         ).getDate();

//         // 🔹 INIT ALL DAYS (YYYY-MM-DD)
//         const dayMap = {};
//         for (let day = 1; day <= daysInMonth; day++) {
//           const dayStr = String(day).padStart(2, "0");
//           const fullDate = `${selectedYear}-${selectedMonth}-${dayStr}`;
//           dayMap[fullDate] = 0;
//         }

//         // 🔹 COUNT PER DAY
//         students.forEach((student) => {
//           const date = new Date(student.subscribedAt)
//             .toISOString()
//             .split("T")[0];

//           if (dayMap[date] !== undefined) {
//             dayMap[date] += 1;
//           }
//         });

//         // 🔹 FINAL DATA
//         const formattedChartData = Object.keys(dayMap).map((date) => ({
//           date, // 👈 YYYY-MM-DD
//           count: dayMap[date],
//         }));

//         setChartData(formattedChartData);
//       }
//     } catch (error) {
//       console.error("Student count fetch error", error);
//     }
//   };

//   useEffect(() => {
//     fetchChart();
//   }, [selectedFilters]);

//   const fetchDashboardStats = async () => {
//     try {
//       const response = await getWithTokenAPI(
//         token,
//         `${institution_dashboard}${id}`,
//       );
//       if (response?.success) {
//         setCourses(response.data?.totalCourses);
//       }
//     } catch (error) {
//       console.error("Error fetching dashboard stats:", error);
//       SafeToast.error("Failed to load dashboard statistics");
//     }
//   };
//   useEffect(() => {
//     fetchDashboardStats();
//     fetchChart();
//   }, []);

//   const fetchProfile = async () => {
//     try {
//       const response = await getWithTokenAPI(token, `/user/profile/${id}`);

//       if (response?.statusCode === 200) {
//         setProfile(response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching user profile:", error);
//     }
//   };

//   useEffect(() => {
//     if (!id || !token) return;
//     fetchProfile();
//   }, [id, token]);

//   const handleBlock = async (isBlockedvalue) => {
//     const payload = {
//       is_block: isBlockedvalue,
//     };

//     const action = profile?.is_block ? "Unblocked" : "Blocked";

//     try {
//       const res = await putWithTokenAPI(token, `/user/update/${id}`, payload);

//       if (res?.statusCode == 200) {
//         SafeToast.success(`Student ${action} successfully`);
//         fetchProfile();
//       } else {
//         SafeToast.error(res?.message || "Failed to update student status");
//       }

//       return res;
//     } catch (error) {
//       console.error("Error updating student status:", error);
//       SafeToast.error("Failed to update student status");
//       throw error;
//     }
//   };

//   return (
//     <div className="student-page">
//       <div className="student-header">
//         <div className="student-title-wrap-particlur">
//           <button className="nav-btn" onClick={() => navigate("/institutions")}>
//             <ChevronLeft size={18} />
//           </button>
//           <h2 className="student-title-particlur">Institutions</h2>

//           <span className="student-name">
//             {" "}
//             <span className="student-arrow"></span>
//             {profile?.nameofInstitution || "Unknown Name"}
//           </span>
//         </div>
//       </div>

//       {/* PROFILE CARD */}
//       <div className="student-card">
//         <div className="student-image">
//           <img src={profile?.logo || Noimage} alt="student" />
//         </div>

//         {/* DETAILS */}
//         <div className="student-info ">
//           <span
//             className={`status-badge ${profile?.status ? "active" : "inactive"}`}
//           >
//             <span className="dot"></span>
//             {profile?.status ? "Active" : "Non Active"}
//           </span>
//           <div className="status-container">
//             <h3 className="name-row">
//               {profile?.nameofInstitution || "Unknown Name"}
//             </h3>
//           </div>
//           <button className="institution-btn">Courses : {Courses}</button>
//           <button
//             className={profile?.is_block ? "unblock-btn" : "block-btn"}
//             onClick={() => handleBlock(!profile?.is_block)}
//           >
//             {profile?.is_block ? "Unblock" : "Block"}
//           </button>{" "}
//         </div>
//       </div>

//       <div className="dashboard-card-ins">
//         {/* Filters Section */}
//         <div className="dashboard-card__filters">
//           <SelectDropdown
//             value={selectedFilters.month}
//             onChange={(value) => handleFilterChange("month", value)}
//             options={filters.months}
//             placeholder="Select Month"
//             width="180px"
//             className="dashboard-card__select"
//           />

//           <SelectDropdown
//             value={selectedFilters.year}
//             onChange={(value) => handleFilterChange("year", value)}
//             options={filters.years}
//             placeholder="Select Year"
//             width="150px"
//             className="dashboard-card__select"
//           />
//         </div>

//         {/* Chart Section */}
//         <div className="dashboard-card__chart">
//           <ResponsiveContainer width="100%" height={320}>
//             <BarChart
//               data={chartData}
//               margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
//             >
//               {/* Gradient */}
//               <defs>
//                 <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
//                   <stop offset="0%" stopColor="#60a5fa" />
//                   <stop offset="100%" stopColor="#2563eb" />
//                 </linearGradient>
//               </defs>

//               <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />

//               <XAxis
//                 dataKey="date"
//                 interval={0}
//                 tick={{ fontSize: 12, fill: "#374151" }}
//                 tickFormatter={(date) => date.split("-")[2]} // 👈 01–30 ONLY
//               />

//               <YAxis
//                 allowDecimals={false}
//                 tick={{ fontSize: 12, fill: "#374151" }}
//               />

//               <Tooltip
//                 contentStyle={{
//                   backgroundColor: "#fff",
//                   borderRadius: "8px",
//                   border: "1px solid #e5e7eb",
//                 }}
//                 labelFormatter={(label) => `Date: ${label.split("-")[2]}`}
//               />

//               <Bar
//                 dataKey="count"
//                 fill="url(#barGradient)"
//                 radius={[8, 8, 0, 0]}
//                 maxBarSize={40}
//               />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Institutionsspecific;


import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { ChevronLeft, Loader2 } from "lucide-react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

import "../../styles/studentProfile.css";
import { getWithTokenAPI, putWithTokenAPI } from "../../util/Api";
import { institution_dashboard } from "../../util/Apiendpoits";
import { SafeToast } from "../Toast/ShowToast";
import Noimage from "../../assets/Noimg3.jpg";
import SelectDropdown from "../ReusableComponent/SelectDropdown";

const Institutionsspecific = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.auth);

  const [profile, setProfile] = useState(null);
  const [coursesCount, setCoursesCount] = useState(0);
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);

  const currentYear = new Date().getFullYear();
  
  // State allows month to be empty for "All Months" view
  const [selectedFilters, setSelectedFilters] = useState({
    month: "", // Default to All Months
    year: String(currentYear),
  });

  const filters = {
    months: [
      { value: "", label: "All Months" },
      { value: "01", label: "January" }, { value: "02", label: "February" },
      { value: "03", label: "March" }, { value: "04", label: "April" },
      { value: "05", label: "May" }, { value: "06", label: "June" },
      { value: "07", label: "July" }, { value: "08", label: "August" },
      { value: "09", label: "September" }, { value: "10", label: "October" },
      { value: "11", label: "November" }, { value: "12", label: "December" },
    ],
    years: Array.from({ length: 5 }, (_, i) => {
      const year = currentYear - i;
      return { value: String(year), label: String(year) };
    }),
  };

  const fetchChartData = useCallback(async () => {
    if (!token || !id) return;
    setLoading(true);
    try {
      const res = await getWithTokenAPI(token, `/institution/${id}/student-count`);
      if (res?.success) {
        const students = res.data?.students || [];
        const { month, year } = selectedFilters;
        const formattedData = [];

        if (month === "") {
          // --- VIEW: 12 MONTHS ---
          filters.months.slice(1).forEach((m) => {
            const count = students.filter((s) => {
              if (!s.subscribedAt) return false;
              const d = new Date(s.subscribedAt);
              return (
                String(d.getFullYear()) === year &&
                String(d.getMonth() + 1).padStart(2, "0") === m.value
              );
            }).length;

            formattedData.push({
              label: m.label.substring(0, 3), // e.g., "Jan"
              fullLabel: m.label,
              count: count,
            });
          });
        } else {
          // --- VIEW: 30 DAYS ---
          const daysInMonth = new Date(Number(year), Number(month), 0).getDate();
          for (let i = 1; i <= daysInMonth; i++) {
            const dayStr = String(i).padStart(2, "0");
            const dateString = `${year}-${month}-${dayStr}`;
            
            const count = students.filter((s) => {
              if (!s.subscribedAt) return false;
              return s.subscribedAt.startsWith(dateString);
            }).length;

            formattedData.push({
              label: dayStr, // e.g., "01"
              fullLabel: `Date: ${dateString}`,
              count: count,
            });
          }
        }
        setChartData(formattedData);
      }
    } catch (error) {
      console.error("Chart fetch error", error);
    } finally {
      setLoading(false);
    }
  }, [id, token, selectedFilters]);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const [profRes, statsRes] = await Promise.all([
          getWithTokenAPI(token, `/user/profile/${id}`),
          getWithTokenAPI(token, `${institution_dashboard}${id}`)
        ]);
        if (profRes?.statusCode === 200) setProfile(profRes.data);
        if (statsRes?.success) setCoursesCount(statsRes.data?.totalCourses || 0);
      } catch (e) { console.error(e); }
    };
    fetchProfileData();
  }, [id, token]);

  useEffect(() => {
    fetchChartData();
  }, [fetchChartData]);

  const handleBlockToggle = async () => {
    const isBlockedValue = !profile?.is_block;
    try {
      const res = await putWithTokenAPI(token, `/user/update/${id}`, { is_block: isBlockedValue });
      if (res?.statusCode === 200) {
        SafeToast.success(`Institution ${isBlockedValue ? "Blocked" : "Unblocked"} successfully`);
        setProfile(prev => ({ ...prev, is_block: isBlockedValue }));
      }
    } catch (error) { SafeToast.error("Update failed"); }
  };

  return (
    <div className="student-page">
      <div className="student-header">
        <div className="student-title-wrap-particlur">
          <button className="nav-btn" onClick={() => navigate("/institutions")}>
            <ChevronLeft size={18} />
          </button>
          <h2 className="student-title-particlur">Institutions</h2>
          <span className="student-name">
             <span className="student-arrow"></span>
             {profile?.nameofInstitution || "Institution Detail"}
          </span>
        </div>
      </div>

      <div className="student-card">
        <div className="student-image">
          <img src={profile?.logo || Noimage} alt="logo" />
        </div>
        <div className="student-info">
          <span className={`status-badge ${profile?.status ? "active" : "inactive"}`}>
            <span className="dot"></span> {profile?.status ? "Active" : "Inactive"}
          </span>
          <h3 className="name-row">{profile?.nameofInstitution || "N/A"}</h3>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button className="institution-btn">Courses: {coursesCount}</button>
            <button 
              className={profile?.is_block ? "unblock-btn" : "block-btn"}
              onClick={handleBlockToggle}
            >
              {profile?.is_block ? "Unblock" : "Block"}
            </button>
          </div>
        </div>
      </div>

      <div className="dashboard-card-ins">
        <div className="dashboard-card__filters">
          <SelectDropdown
            value={selectedFilters.month}
            onChange={(val) => setSelectedFilters(prev => ({ ...prev, month: val }))}
            options={filters.months}
            placeholder="Select Month"
            width="180px"
          />
          <SelectDropdown
            value={selectedFilters.year}
            onChange={(val) => setSelectedFilters(prev => ({ ...prev, year: val }))}
            options={filters.years}
            placeholder="Select Year"
            width="150px"
          />
        </div>

        <div className="dashboard-card__chart" style={{ position: 'relative', minHeight: '320px' }}>
          {loading && (
            <div className="loader-overlay" style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.6)', zIndex: 10 }}>
              <Loader2 className="animate-spin" size={32} />
            </div>
          )}
          
          <ResponsiveContainer width="100%" height={320}>
            <BarChart data={chartData} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
              <defs>
                <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#60a5fa" />
                  <stop offset="100%" stopColor="#2563eb" />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" vertical={false} />
              <XAxis 
                dataKey="label" 
                tick={{ fontSize: 12 }}
                interval={selectedFilters.month === "" ? 0 : 1} // Show all months, but skip some days for clarity
              />
              <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
              <Tooltip 
                labelFormatter={(_, payload) => payload[0]?.payload?.fullLabel || ""}
                contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
              />
              <Bar dataKey="count" fill="url(#barGradient)" radius={[4, 4, 0, 0]} maxBarSize={40} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default Institutionsspecific;